"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchNotificationsSaga = void 0;
const constants_1 = require("@/app/shared/constants");
const effects_1 = require("redux-saga/effects");
const actions_1 = require("./actions");
const selectors_1 = require("./selectors");
function* showToastSaga(action) {
    if (action.type !== actions_1.NotificationsActionTypes.SHOW_TOAST)
        return;
    try {
        const toastNotificationsQueue = yield (0, effects_1.select)(selectors_1.notificationsSelectors.selectToastNotificationsQueue);
        const [firstToastId] = toastNotificationsQueue;
        if (toastNotificationsQueue.length >= constants_1.TOASTS_QUEUE_MAX_LENGTH && firstToastId) {
            yield (0, effects_1.put)(actions_1.notificationsActions.hideToast({ id: firstToastId }));
        }
        yield (0, effects_1.put)(actions_1.notificationsActions.addToastToQueue(action.payload));
    }
    catch (error) {
        console.log(`🚀 ~ showToastSaga ~ error:`, error);
    }
}
// function* hideToastSaga(action: ReturnType<typeof notificationsActions.hideToast>) {
//   if (action.type === NotificationsActionTypes.HIDE_TOAST) {
//     const { payload } = action;
//     const toastNotificationsQueue: ToastNotification[] = yield select(
//       notificationsSelectors.selectToastNotificationsQueue
//     );
//     const currentToast = toastNotificationsQueue.find((toast) => toast.id === payload);
//     currentToast?.timerId && clearTimeout(currentToast.timerId);
//     yield put(notificationsActions.removeToastFromQueue(payload));
//   }
// }
function* watchNotificationsSaga() {
    yield (0, effects_1.takeLatest)(actions_1.NotificationsActionTypes.SHOW_TOAST, showToastSaga);
    // yield takeLatest(NotificationsActionTypes.HIDE_TOAST, hideToastSaga);
}
exports.watchNotificationsSaga = watchNotificationsSaga;
